import React, { memo } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { EQUIPMENT_OPTIONS } from 'apps/spot-quote-control-panel/constants/spotBiddingConfig'
import {
  PARENT_EQUIPMENT_KEY,
  ISpotBiddingRule,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface IEquipmentProps {
  value: PARENT_EQUIPMENT_KEY
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
}

export const Equipment = memo<IEquipmentProps>(({ onChange, value }) => {
  const equipmentHandler = (e: ISelectOption<PARENT_EQUIPMENT_KEY>) => {
    onChange({ parentEquipmentKey: e.value })
  }

  return (
    <div className='col-md-6 col-xs-4'>
      <Select
        label='Equipment Type'
        options={EQUIPMENT_OPTIONS}
        value={value}
        onChange={equipmentHandler}
        dataTest='modal-equipment'
        required
        large
      />
    </div>
  )
})
